<script setup>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tag from 'primevue/tag';
import ArgonButton from "@/components/Argon/ArgonButton.vue";

defineProps({
  invoices: {
    type: Array,
    default: () => []
  }
});

const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString('en-GB');
};

const formatCurrency = (amount, currency) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currency || 'GBP'
  }).format(amount);
};

const getStatusSeverity = (status) => {
  if (status === 'paid') return 'success';
  if (status === 'open' || status === 'draft') return 'warning';
  if (status === 'uncollectible' || status === 'void') return 'danger';
  return 'info';
};
</script>

<template>
  <div class="card">
    <div class="card-header">
      <h6 class="mb-0">Invoice History</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <DataTable :value="invoices" responsiveLayout="scroll">
        <Column field="created" header="Date" sortable>
          <template #body="{ data }">
            {{ formatDate(data.created) }}
          </template>
        </Column>
        <Column field="status" header="Status" sortable>
          <template #body="{ data }">
            <Tag :severity="getStatusSeverity(data.status)" class="text-capitalize">{{ data.status }}</Tag>
          </template>
        </Column>
        <Column field="total" header="Amount" sortable>
          <template #body="{ data }">
            {{ formatCurrency(data.total, data.currency) }}
          </template>
        </Column>
        <Column header="Actions">
          <template #body="{ data }">
            <a :href="data.invoice_pdf" target="_blank" rel="noopener noreferrer">
              <ArgonButton color="secondary" size="sm" class="mb-0">
                <i class="fas fa-file-pdf me-2"></i>View PDF
              </ArgonButton>
            </a>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>
